export type SocialMediaLink = {
  link: string;
  trackingName: string;
  image: {
    src: string;
    alt: string;
  };
};
